<template>
  <div id="maintenance" class="section">
    <h1>
      <span class="section-title">Maintenance</span>
      <span class="section-description">{{ $t('maintenance.title') }}</span>
    </h1>
    <div class="margin-top-30px has-text-weight-bold">
      <p>お客様の大事な資産を守るため、メンテナンスを行っております。</p>
      <p>ご迷惑をおかけしておりますが、今しばらくお待ちください。</p>
    </div>
    <div class="margin-top-30px has-text-weight-bold">
      <p>メンテナンスの最新状況はこちらからご確認いただけます</p>
      <div class="buttons is-centered">
        <a href="https://status.hcloud.ltd/status/hstorage" target="_blank" rel="noreferrer">
          <b-button type="is-primary has-text-weight-bold" rounded>サービス稼働状況を確認する</b-button>
        </a>
        <a href="https://forum.hstorage.io/c/incident/42" target="_blank" rel="noreferrer">
          <b-button type="is-primary has-text-weight-bold" rounded>障害情報を確認する</b-button>
        </a>
      </div>
    </div>
  </div>
</template>


<script>

import appConfig from "../app.config.json";
import { useHead } from "@unhead/vue";

export default {
  name: "Maintenance",
  data() {
    return {
    }
  },
  created() {
    useHead({
      title: `${this.$t('maintenance.title')} | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        { name: 'description', content: appConfig[this.$i18n.locale].description.top },
        { name: 'robots', content: 'noindex,nofollow' }
      ]
    })
  }
}
</script>

<style scoped></style>
